module.exports = __webpack_public_path__ + "h5/img/presell_bg.270846f2.jpg";